<template>
  <div
    class="FilterPlusMinusIcon"
    :class="{ 'FilterPlusMinusIcon--active': props.active }"
  />
</template>

<script setup lang="ts">
interface Props {
  active: boolean
}

const props = defineProps<Props>()
</script>

<style lang="postcss" scoped>
.FilterPlusMinusIcon {
  @apply relative w-3 h-3 order-1 lg:order-2;

  &:before,
  &:after {
    @apply bg-off-black content-[''] absolute;

    transition: transform 0.25s ease-out;
  }

  /* Vertical line */
  &:before {
    @apply top-0 left-1/2 w-0.5 h-full ml-[-1px];
  }

  /* horizontal line */
  &:after {
    @apply top-1/2 left-0 w-full h-0.5 mt-[-1px];
  }
}

.FilterPlusMinusIcon--active {
  &:before {
    transform: rotate(90deg);
  }

  &:after {
    transform: rotate(180deg);
  }
}
</style>
